var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummaryPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Color / Valoracion Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.001,13 C21.68,13 21.357,13.247 21.112,13.742 L18.468,19.101 L12.534,19.965 C11.444,20.124 11.194,20.884 11.986,21.655 L16.273,25.836 L15.262,31.747 C15.127,32.536 15.431,33 15.98,33 C16.188,33 16.431,32.934 16.698,32.793 L22,30.006 L27.302,32.793 C27.57,32.934 27.813,33 28.022,33 C28.571,33 28.875,32.536 28.739,31.747 L27.728,25.836 L32.014,21.655 C32.805,20.884 32.557,20.124 31.465,19.965 L25.533,19.101 L22.889,13.742 C22.646,13.247 22.323,13 22.001,13",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.001,10 C19.68,10 19.357,10.247 19.112,10.742 L16.468,16.101 L10.534,16.965 C9.444,17.124 9.194,17.884 9.986,18.655 L14.273,22.836 L13.262,28.747 C13.127,29.536 13.431,30 13.98,30 C14.188,30 14.431,29.934 14.698,29.793 L20,27.006 L25.302,29.793 C25.57,29.934 25.813,30 26.022,30 C26.571,30 26.875,29.536 26.739,28.747 L25.728,22.836 L30.014,18.655 C30.805,17.884 30.557,17.124 29.465,16.965 L23.533,16.101 L20.889,10.742 C20.646,10.247 20.323,10 20.001,10 M20.001,13.462 L21.739,16.986 L22.205,17.928 L23.245,18.08 L27.154,18.65 L24.331,21.404 L23.578,22.138 L23.756,23.173 L24.423,27.071 L20.931,25.235 L20,24.746 L19.069,25.235 L15.578,27.07 L16.244,23.173 L16.422,22.138 L15.67,21.404 L12.846,18.649 L16.756,18.08 L17.797,17.928 L18.262,16.986 L20.001,13.462",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Color-/-Valoracion-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FA504C",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Valoracion",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 10.000000)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#444444",
    xlinkHref: "#path-3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryPay);
export default __webpack_public_path__ + "static/media/summary-pay.abd0d659064f98d796d6b0aa2db7e326.svg";
export { ForwardRef as ReactComponent };